// extracted by mini-css-extract-plugin
export var brand = "_2p-9";
export var compact = "_2p-6";
export var extraSmall = "_2p-7";
export var icon = "_2p-0";
export var large = "_2p-4";
export var light = "_2p-1";
export var medium = "_2p-5";
export var outline = "_2p-b";
export var primaryDark = "_2p-a";
export var primaryLight = "_2p-8";
export var primaryModern = "_2p-c";
export var success = "_2p-2";
export var successSolid = "_2p-3";